(function () {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  const OPEN_CLASS = 'cart-drawer-open';
  const FALLBACK_MS = 600;
  let closeTimer;

  if ('showPopover' in drawer && !drawer.hasAttribute('popover')) {
    drawer.setAttribute('popover', 'manual');
  }

  function show() {
    clearTimeout(closeTimer);
    document.documentElement.classList.add(OPEN_CLASS);
    try {
      if (drawer.hasAttribute('popover') && !drawer.matches(':popover-open')) {
        drawer.showPopover();
      }
    } catch (e) {}
  }

  function hide() {
    document.documentElement.classList.remove(OPEN_CLASS);

    const done = () => {
      clearTimeout(closeTimer);
      if (drawer.hasAttribute('open')) return; // reopened mid-animation
      try {
        if (drawer.matches(':popover-open')) drawer.hidePopover();
      } catch (e) {}
    };

    const content = drawer.shadowRoot && drawer.shadowRoot.querySelector('[part="content"]');
    if (content) content.addEventListener('transitionend', done, { once: true });
    closeTimer = setTimeout(done, FALLBACK_MS);
  }

  new MutationObserver(() => (drawer.hasAttribute('open') ? show() : hide()))
    .observe(drawer, { attributes: true, attributeFilter: ['open'] });

  if (drawer.hasAttribute('open')) show();
})();